import { Component, HostListener, OnInit } from '@angular/core';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit {
  isMobile: boolean = false;
  corporateAccount: CorporateAccountDto;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  constructor(
    private readonly authService: AuthenticationService,
    private corporateAccountService: CorporateAccountService
  ) {}

  ngOnInit() {
    this.checkWindowSize();

    this.corporateAccountService.get().subscribe((getResult) => {
      this.corporateAccount = getResult.data;
    });
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth <= 820;
  }
}
